// API client utility for making requests to the backend.
// Production: VITE_API_URL is baked in at build time (pipeline sets it to VITE_APP_URL).

const getApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_URL) {
    return (import.meta.env.VITE_API_URL as string).replace(/\/$/, '')
  }
  return ''
}

export const apiBaseUrl = getApiBaseUrl()

export const apiFetch = async (path: string, options?: RequestInit): Promise<Response> => {
  const url = path.startsWith('http') ? path : `${apiBaseUrl}${path}`
  return fetch(url, {
    ...options,
    credentials: 'include', // Include cookies for session management
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

